module.exports = __webpack_public_path__ + "static/media/HS_portal_logo.7ab13948.svg";